<script lang="ts">
  import DirectFileUpload from '../shared/DirectFileUpload.svelte'
  import axios from 'axios'

  let {
    user: initialUser
  } = $props()

  let user = $state(JSON.parse(initialUser))
  let submitting = $state(false)

  function imageChanged(image) {
    submitting = true
    user.avatar_url = image
  }

  function uploadChanged(upload) {
    submitting = false
    if (upload) {
      user.avatar = upload.signed_id
    } else {
      user.avatar = null
    }
  }

  function uploadError(error) {
    console.log('uploadError', error)
    // set form errors
  }

  async function submit(evt) {
    evt.preventDefault()
    if (submitting) return

    submitting = true

    axios.put(`/users/${user.id}`, {
      user: {
        avatar: user.avatar,
        remove_avatar: user.remove_avatar
      },
      form_panel: 'profile_photo'
    })
      .then(_response => {
        window.toastr.info('Profile photo updated successfully')
      })
      .finally(() => submitting = false)
  }
</script>

<div class="panel panel--settings js-settings-panel">
  <div class="flex-row js-btn-toggle-panel">
    <div class="cell-1">
      <div class="title">
        Profile Photo
      </div>
      <div class="description">
        This will appear as your avatar
      </div>
    </div>
    <div class="cell-1">
      <div class="text-right">
        <button class="btn btn-rounded btn-toggle btn-open" type="button">Expand</button>
        <button class="btn btn-rounded btn-toggle btn-close" type="button">Close</button>
      </div>
    </div>
  </div>

  <div class="form-wrapper">
    <form class="form-inline" onsubmit={(e) => submit(e)}>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <DirectFileUpload
              {imageChanged}
              {uploadChanged}
              {uploadError}
              mimeTypes="image/*"
            />
          </div>

          <div class="form-group save-btn">
            <button class="btn btn-success" type="submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Save'}
            </button>
          </div>
        </div>

        <div class="col-md-6">
          <div class="image-upload-preview">
            Preview:
            {#if user.avatar_url}
              <img src={user.avatar_url} alt="User avatar" />

              <div
                class="form-group hide-unless-upload">
                <div class="checkbox">
                  <label for="remove_avatar">
                    <input type="checkbox" id="remove_avatar" bind:checked={user.remove_avatar} />
                    Remove Profile Image
                  </label>
                </div>
              </div>
            {/if}
          </div>

        </div>
      </div>
    </form>
  </div>

</div>

<style lang="scss">
  .save-btn {
    vertical-align: top;
  }
</style>
